module.exports = {
  box_3_title: '3x-correct-box (learned)',
  box_2_title: '2x-correct-box',
  box_1_title: '1x-correct-box',
  box_0_title: 'New questions box',
  how_does_it_work: 'What is Powerlearning?',
  question_learned: 'Question learned!',
  go_to_powerlearning: 'To powerlearning',
  learning: {
    congratulations: 'Congratulations!',
    all_questions_done: 'You have answered all of the questions in this box.',
  },
  to_box_overview: 'To the box overview',
  currently_no_questions: 'There are currently no questions in the box for this category. Answer the questions in the boxes below to take questions to the next level:',
  explanation1: 'In training mode, a question must be answered correctly three times in order to be considered "learned."',
  explanation2: 'The system only asks questions that have not yet been marked as learned. There are no time limits or restrictions.',
  explanation3: 'If a question is answered incorrectly, the question is returned to the "Fresh Questions Box"',
  how_does_it_work_short: 'How does powerlearning work?',
  intro_text: 'Powerlearning strengthens your knowledge by repeating the learning content several times.',
  choose_box: 'Select box',
  close: 'End powerlearning',
  n_questions: '1 question | %{n} questions',
  n_questions_remaining: '1 question left | %{n} questions left',
  n_questions_learned: '1 question learned | %{n} questions learned',
  n_questions_remaining_in_box: '1 more question in this box | %{n} more questions in this box',
  n_questions_in_box: '1 question in this box | %{n} questions in this box',
  x_of_y_questions_learned: '%{x} of %{y} questions learned',
}
